/**
 * Category Icons Library
 * 16 stroke-based SVG icons for restaurant product categories.
 * Each icon function accepts { size, color } props.
 */

const icons = {
  flame: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2c0 0-4 4-4 9a4 4 0 0 0 8 0c0-1.5-.5-3-1.5-4.5" />
      <path d="M12 2c0 0 2 2.5 2 5.5a2 2 0 0 1-4 0C10 5.5 12 2 12 2z" />
      <path d="M8.5 16.5c-.8 1-1.5 2.5-1.5 4a5 5 0 0 0 10 0c0-1.5-.7-3-1.5-4" />
    </svg>
  ),

  cocktail: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3h12l-6 8-6-8z" />
      <line x1="12" y1="11" x2="12" y2="19" />
      <line x1="8" y1="19" x2="16" y2="19" />
      <path d="M9 7.5l6 0" />
    </svg>
  ),

  coffee: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2c0 2 2 2 2 4" />
      <path d="M12 2c0 2 2 2 2 4" />
      <rect x="3" y="8" width="14" height="9" rx="2" />
      <path d="M17 10h2a2 2 0 0 1 0 4h-2" />
      <line x1="2" y1="21" x2="20" y2="21" />
    </svg>
  ),

  dessert: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 14c0-4.4 3.6-8 8-8s8 3.6 8 8" />
      <rect x="2" y="14" width="20" height="3" rx="1" />
      <line x1="12" y1="6" x2="12" y2="4" />
      <line x1="9" y1="17" x2="9" y2="21" />
      <line x1="15" y1="17" x2="15" y2="21" />
    </svg>
  ),

  pizza: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 19h20L12 2z" />
      <line x1="12" y1="2" x2="12" y2="19" />
      <circle cx="9" cy="12" r="1" />
      <circle cx="14" cy="9" r="1" />
      <circle cx="11" cy="16" r="1" />
    </svg>
  ),

  sushi: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="13" rx="8" ry="5" />
      <ellipse cx="12" cy="13" rx="4" ry="2.5" />
      <path d="M9 5c0-1.5 1-2.5 3-2.5s3 1 3 2.5" />
      <line x1="12" y1="5" x2="12" y2="10.5" />
    </svg>
  ),

  grill: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 8h12" />
      <path d="M3 5h18a9 9 0 0 1-18 0z" />
      <path d="M12 14v7" />
      <path d="M8 18l4 3 4-3" />
    </svg>
  ),

  salad: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 10c-1-3 1-7 5-7s6 4 5 7" />
      <path d="M5 10c-2 0-3 1-3 3 0 3 4 7 10 7s10-4 10-7c0-2-1-3-3-3H5z" />
      <path d="M12 3v4" />
      <path d="M9 14c1 1 5 1 6 0" />
    </svg>
  ),

  'ice-cream': ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 11a5 5 0 0 1 10 0" />
      <path d="M7 11c0 2.5 2 4 5 4s5-1.5 5-4" />
      <path d="M9 15l3 7 3-7" />
    </svg>
  ),

  juice: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 3h8l1 5H7L8 3z" />
      <path d="M7 8l1 13h8l1-13" />
      <path d="M10 13c.5-1 1.5-1 2 0s1.5 1 2 0" />
      <line x1="14" y1="3" x2="16" y2="1" />
    </svg>
  ),

  fish: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12c0 0 4-6 10-6s10 6 10 6-4 6-10 6S2 12 2 12z" />
      <path d="M20 12l2-4v8l-2-4z" />
      <circle cx="9" cy="11" r="1.2" />
      <path d="M13 10c1 .5 2 1.5 2 2s-1 1.5-2 2" />
    </svg>
  ),

  bread: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 11c0-4 3-7 8-7s8 3 8 7c0 1-1 2-2 2H6c-1 0-2-1-2-2z" />
      <rect x="4" y="13" width="16" height="6" rx="1" />
      <line x1="8" y1="13" x2="8" y2="19" />
      <line x1="16" y1="13" x2="16" y2="19" />
    </svg>
  ),

  utensils: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 2v7c0 2 2 4 4 4v9" />
      <path d="M5 2v5" />
      <path d="M7 2v5" />
      <path d="M15 2a5 5 0 0 1 5 5v2h-5v13" />
    </svg>
  ),

  truck: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="7" width="14" height="11" rx="1" />
      <path d="M15 12h4l3 4v3h-7v-7z" />
      <circle cx="6" cy="20" r="2" />
      <circle cx="18" cy="20" r="2" />
      <line x1="1" y1="12" x2="15" y2="12" />
    </svg>
  ),

  package: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.5 9.5l-9-5.25" />
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),

  star: ({ size = 20, color = 'currentColor' } = {}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
};

export const ICON_KEYS = [
  'flame',
  'cocktail',
  'coffee',
  'dessert',
  'pizza',
  'sushi',
  'grill',
  'salad',
  'ice-cream',
  'juice',
  'fish',
  'bread',
  'utensils',
  'truck',
  'package',
  'star',
];

export const getCategoryIcon = (key, props = {}) => {
  const iconFn = icons[key] || icons['star'];
  return iconFn(props);
};

export default icons;
